import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import I18n from 'i18n-react'
import { cookie } from 'devx-js-utilities'

class CalculateContainer extends React.Component {
	static propTypes = {
		calculateResult: PropTypes.number.isRequired,
	}

	state = {
		calculateResult: 0
	}

	componentWillMount() {
		if (this.props.calculateResult > 0) {
			this.setState({ calculateResult: this.props.calculateResult })
			cookie.createCookie('domex-price', this.props.calculateResult, 60)
		} else {
			const priceFromCookie = parseInt(cookie.readCookie('domex-price'), 10)
			if (priceFromCookie) {
				this.setState({ calculateResult: priceFromCookie })
			}
		}
	}

	render() {
		return (
			<div className='mt-4'>
				<div id='domex-finalContent'>
					<p className='domex-finalScreen-title'>
						{I18n.translate('general.calculateResult')}
						&nbsp;<span className='h3 text-primary'>{this.state.calculateResult}</span>&nbsp;
						{I18n.translate('general.currency')}
					</p>
					<p>{I18n.translate('general.calculateDetail')}</p>
				</div>
				<div id='surikata'/>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	calculateResult: state.domex.calculateResult
})

export default connect(mapStateToProps, null)(CalculateContainer)
